module.exports = __webpack_public_path__ + "static/media/cities.afb0fa89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/cities.svg
// module id = 78
// module chunks = 0